import React, {Fragment} from "react";
import ListView from "../../../components/ContentDisplay/ListView";
import DeleteModal from "../../../components/Modal/DeleteModal";
import AddSim from "../../../components/Modal/AddSim";
import SimUsage from "../../../components/Modal/SimUsage";
import {SimCard} from "./simCard";
import {
  ACTIONS_LIST,
  LIST_HEADERS,
  PERMS_FOR_ACTIONS,
  SORTABLE_FIELDS,
} from "./simTable.constants";
import {useSearchOptions} from "./useSimSearchOptions";
import {useSimTableActions} from "./useSimTableActions";
import {useSimTableData} from "./useSimTableData";

const SimsTable = () => {
  const {searchOptions} = useSearchOptions();
  const {fetchAfterDelete, handleSearch, paginationConfig, sims, totalCount} =
    useSimTableData();
  const {
    deleteModalStatus,
    deleteSim,
    editModalStatus,
    handleActionSelection,
    handleToggle,
    setDeleteModalStatus,
    setEditModalStatus,
    setUsageModalStatus,
    usageModalStatus,
  } = useSimTableActions(fetchAfterDelete);

  return (
    <Fragment>
      <SimUsage open={usageModalStatus} onClose={() => setUsageModalStatus(false)} />
      <AddSim open={editModalStatus} onClose={() => setEditModalStatus(false)} />
      <DeleteModal
        header={"Delete SIM"}
        modalBody={"Are you sure you want to delete this Sim ?"}
        onClose={() => setDeleteModalStatus(false)}
        onDelete={deleteSim}
        open={deleteModalStatus}
      />
      <ListView
        cardContent={SimCard}
        listItems={sims}
        listHeaders={LIST_HEADERS}
        onSelectAction={handleActionSelection}
        withActions
        actionsList={ACTIONS_LIST}
        permsForActions={PERMS_FOR_ACTIONS}
        booleanAsToggle
        onClickToggle={handleToggle}
        toggleTestId={"switch_status"}
        totalCount={totalCount}
        withPagination={paginationConfig}
        withSearchQuery={true}
        searchPlaceHolder={"Filter Sims"}
        searchOptions={searchOptions}
        handleSearch={handleSearch}
        sortableFields={SORTABLE_FIELDS}
      />
    </Fragment>
  );
};

export default SimsTable;
